import { render, staticRenderFns } from "./systemInitManage.vue?vue&type=template&id=5f4e6f1c"
import script from "./systemInitManage.vue?vue&type=script&lang=js"
export * from "./systemInitManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports